import { ManualShipmentsModule } from '@/shared';

export default ManualShipmentsModule;
